<div>
  <app-main-content></app-main-content>
</div>